export interface PricingCalculationPayload {
	planType: string;
	numUsers: number;
	discountPercentage: number;
	state: string;
	billingCycle: 'Annual' | 'Quarter';
	fbAdsChecked: boolean;
	fbAdsPremiumChecked: boolean;
	gLSAChecked: boolean;
	customContentChecked: boolean;
	customContentNonprofit: boolean;
	handwritten: boolean;
	splitBilling: boolean;
	special: string;
	quarterlyVerbiage: string;
}

export interface PricingCalculationResponse {
	// API response fields (numbers for display)
	basePrice?: number;
	extraUserCost?: number;
	onboardingFee?: number;
	facebookAdsFee?: number;
	googleLSAFee?: number;
	customContentFee?: number;
	subtotal?: number;
	renewalSubtotal?: number;
	discountAmount?: number;
	totalBeforeTaxes?: number;
	taxAmount?: number;
	annualTotal?: number;
	quarterlyTotal?: number;
	splitTotal?: number;
	renewalAnnualTotal?: number;
	renewalQuarterlyTotal?: number;
	mrrAmount?: number;
	offerUrl?: string;
	cacheInfo?: { entries: number; refreshed: string };
	// Form data for proposal generation
	planType?: string;
	numUsers?: number;
	billingCycle?: string;
	state?: string;
	discountPercentage?: number;
	fbAdsChecked?: boolean;
	fbAdsPremiumChecked?: boolean;
	gLSAChecked?: boolean;
	customContentChecked?: boolean;
	customContentNonprofit?: boolean;
	handwritten?: boolean;
	splitBilling?: boolean;
	// Calculated fields for proposal generation
	planAddons?: string;
	pricingMonthly?: number;
	impFeePrice?: number;
	pricingAnnual?: number;
	totalCost?: number;
	quarterlyCost?: number;
	quarterlyVerbiage?: string;
	splitBillingVerbiage?: string;
	splitBillingCost?: number;
	discountSubtotal?: number;
}

export interface PlanOption {
	value: string;
	label: string;
}

export const PLAN_OPTIONS: PlanOption[] = [
	{ value: '$349 Client Happiness with AI', label: '$349 Client Happiness with AI' },
	{ value: '$369 Client Happiness', label: '$369 Client Happiness' },
	{ value: '$399 Client Happiness Advanced', label: '$399 Client Happiness Advanced' },
	{
		value: '$598 Client Happiness Advanced + Essential Website',
		label: '$598 Client Happiness Advanced + Essential Website',
	},
	{
		value: '$648 Client Happiness Advanced + Preferred Website',
		label: '$648 Client Happiness Advanced + Preferred Website',
	},
	{
		value: '$698 Client Happiness Advanced + Prestige Website',
		label: '$698 Client Happiness Advanced + Prestige Website',
	},
	{ value: '$299 Essential Standalone Website', label: '$299 Essential Standalone Website' },
	{ value: '$349 Preferred Standalone Website', label: '$349 Preferred Standalone Website' },
	{ value: '$399 Prestige Standalone Website', label: '$399 Prestige Standalone Website' },
];
